import * as tslib_1 from "tslib";
import React, { PureComponent } from 'react';
import { isFiniteNumber } from '../../../utils/checks';
import Indicator from './Indicator';
import Styles from "./SurveysValueViewChart.css";

var SurveysValueViewChart =
/** @class */
function (_super) {
  tslib_1.__extends(SurveysValueViewChart, _super);

  function SurveysValueViewChart() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  SurveysValueViewChart.prototype.render = function () {
    var value = this.props.value;
    var positiveValue;
    var negativeValue;

    if (isFiniteNumber(value)) {
      positiveValue = value;
      negativeValue = 100 - value;
    }

    return React.createElement("div", {
      className: Styles.surveysValueViewChart
    }, React.createElement(Indicator, {
      value: positiveValue,
      dimension: "positive"
    }), React.createElement("span", {
      className: Styles.separator
    }), React.createElement(Indicator, {
      value: negativeValue,
      dimension: "negative"
    }));
  };

  return SurveysValueViewChart;
}(PureComponent);

export default SurveysValueViewChart;